import { Table } from '@mantine/core';
import type { UseQueryResult } from 'react-query';
import { NoDataFoundTableRow } from '../../../components/DataTable';
import { LoadingRows } from '../../../components/LoadingRows';
import { Title } from '../../../components/Title';
import { formatToCurrency } from '../../../util/formatting';
import type { ApiResponse } from '../../../util/types/Response';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { PromotionProductDto } from '../types/PromotionDto';
import { KeyedRow } from '../../../components/KeyedRow';

interface PromotionRowProductsProps {
	productsQuery: UseQueryResult<ApiResponse<PromotionProductDto[]>, unknown>;
}

export function PromotionRowProducts({
	productsQuery,
}: PromotionRowProductsProps) {
	return (
		<>
			<Table highlightOnHover>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'SKUID'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Description'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Department'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Group'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Supplier'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Pip Code'} />
						</Table.Th>
						<Table.Th>
							<Title label={'VAT'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Inc VAT Price'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Case Cost'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Case Quantity'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Item Size'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{!productsQuery.isLoading ? (
						<>
							{productsQuery.data?.value.map(
								(promotion: PromotionProductDto) => (
									<KeyedRow>
										<Table.Td>{undefinedCheck(promotion.skuid)}</Table.Td>
										<Table.Td>{undefinedCheck(promotion.description)}</Table.Td>
										<Table.Td>{undefinedCheck(promotion.department)}</Table.Td>
										<Table.Td>{undefinedCheck(promotion.group)}</Table.Td>
										<Table.Td>{undefinedCheck(promotion.supplier)}</Table.Td>
										<Table.Td>{undefinedCheck(promotion.pipCode)}</Table.Td>
										<Table.Td>{formatToCurrency(promotion.vat)}</Table.Td>
										<Table.Td>
											{formatToCurrency(promotion.incVatPrice)}
										</Table.Td>
										<Table.Td>{formatToCurrency(promotion.caseCost)}</Table.Td>
										<Table.Td>{promotion.caseQuantity}</Table.Td>
										<Table.Td>{promotion.itemSize}</Table.Td>
									</KeyedRow>
								),
							)}
							{productsQuery.data && productsQuery.data?.value.length < 1 && (
								<NoDataFoundTableRow />
							)}
						</>
					) : (
						<LoadingRows columnSpan={11} rows={1} />
					)}
				</Table.Tbody>
			</Table>
		</>
	);
}
